import { Box, useMediaQuery, useTheme } from '@mui/material';
import Head from 'next/head';
import { ReactNode, useEffect, useState } from 'react';
import { Footer } from '@src/components/Footer';
import Navbar from '@src/components/Navbar/Navbar';
import { AdFooter, App, Maybe } from '@src/lib/__generated/contentful/sdk';
interface LayoutPropsInterface {
  children: ReactNode;
  appData: Maybe<App>;
  footerData: Maybe<AdFooter>;
  isFooterLite?: boolean;
  isFooterAlt?: boolean;
  withSimpleLayout?: boolean;
  locale: string;
  preview: boolean;
  logoHref: string;
  pageProps: any;
  sx?: object;
}
export const Layout = ({
  children,
  sx = {}
}: LayoutPropsInterface) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);
  if (!isClient) {
    return null;
  }
  return <Box sx={{
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    bgcolor: isSmallScreen ? 'backgrounds.white' : 'backgrounds.neutral',
    ...sx
  }} data-sentry-element="Box" data-sentry-component="Layout" data-sentry-source-file="layout.tsx">
			<Head data-sentry-element="Head" data-sentry-source-file="layout.tsx">
				<title>Book A Visit | WellNow Urgent Care</title>
			</Head>
			<Navbar data-sentry-element="Navbar" data-sentry-source-file="layout.tsx" />
			{children}
			<Footer data-sentry-element="Footer" data-sentry-source-file="layout.tsx" />
		</Box>;
};